/**
 * When does an edit continue the previous one, and when is it its own undo step?
 *
 * Edits to a block are debounced before they reach the undo stack, because typing is not an edit a
 * teacher wants to take back one character at a time. But debouncing on the clock alone coalesces
 * by accident: flipping three switches in the options drawer inside the same window collapsed into
 * a single op, and undo then put all three back at once — which is neither what was done nor what
 * anyone asked to undo.
 *
 * The rule is about WHICH field moved, not how fast. A session continues while it keeps touching
 * fields it has already touched: typing rewrites `question` over and over and stays one op, while
 * each switch names a different key and starts its own. Nothing has to be declared at the call
 * site — no block tells the page which of its controls is a toggle and which is a text box, which
 * is what makes this work the same way in all fifteen of them.
 */
export function continuesSession(touched: ReadonlySet<string>, delta: readonly string[]): boolean {
  return delta.every(field => touched.has(field));
}
